module.exports = "/images/ico-paypal.svg?a0dcb25c783a5d35ec9be1f2a45bdd7f";